import { render, staticRenderFns } from "./Umsatz.vue?vue&type=template&id=467390a0&scoped=true"
import script from "./Umsatz.vue?vue&type=script&lang=js"
export * from "./Umsatz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467390a0",
  null
  
)

export default component.exports